import React, { useMemo, useState, useEffect } from "react";

import {
  SYNC,
  SET_ACTIVE_SMARTPHONE,
  SET_ACTIVE_TARIFF,
  useOfferConfigurator,
} from "features/Offer";

import { OfferList } from "components/organisms";

import { useHardwareRootInfo } from "utils/fetchData";

import { useFilterProvider } from "./FilterProvider";
import { prepareItems } from "./filteredItemUtils";

/**
 * Collection component for filtered items
 */
export default function FilteredItems() {
  const {
    state: { items, unfilteredItems, sortDirection, sortByName, displayType },
  } = useFilterProvider();

  const {
    dispatch,
    state: { activeTariff, activeVariantId, isListingPage },
  } = useOfferConfigurator();

  const [variableQueryParams, setVariableQueryParams] = useState(null);
  const { refetch } = useHardwareRootInfo(variableQueryParams, {
    enabled: false,
  });

  const buildNewExtendedVariants = async () => {
    const {
      data,
      data: {
        hardware: { extendedVariants },
      },
    } = await refetch(variableQueryParams);

    const isSelectedTariff = extendedVariants.filter((item) => {
      if (item.isSelected === true) {
        return item;
      }
      return null;
    })[0];

    dispatch({
      type: SYNC,
      payload: {
        rootInfo: data,
        extendedVariants,
      },
    });

    dispatch({
      type: SET_ACTIVE_TARIFF,
      payload: {
        calculateExtendTariff: isSelectedTariff,
      },
    });

    window.scrollTo({ top: 0 });
  };

  useEffect(() => {
    if (variableQueryParams) {
      buildNewExtendedVariants();
    }
  }, [variableQueryParams]);

  const isTariff = !!(items.length > 0 && items[0].carrier);

  const preparedItems = useMemo(
    () => prepareItems(items, sortDirection, sortByName, isTariff),
    [sortDirection, sortByName, items, isTariff]
  );

  const handleClick = (offerItem, extendedVariant) => {
    if (isListingPage) return;

    if (!isTariff) {
      dispatch({
        type: SET_ACTIVE_SMARTPHONE,
        payload: offerItem,
      });
      window.scrollTo({ top: 0 });
      return;
    }

    const { carrier, urlName, url } = offerItem;

    const {
      offerType,
      offerGroupUrl,
      manufacturerUrl,
      variant: {
        color: { name },
        storage,
        ebootisId,
      },
    } = extendedVariant;

    const params = {
      carrier: carrier.toLowerCase().replace(" ", "-"),
      tariff: urlName || url,
      offerType,
      offerGroupUrl,
      color: name.toLowerCase(),
      storage,
      activeVariantId: ebootisId,
      manufacturer: manufacturerUrl,
    };

    // change call params for useRawTariffVariants
    setVariableQueryParams(params);
  };

  return (
    <OfferList
      initialItemAmount={window.PAGE_TYPE === "hardware" ? 6 : 12}
      isLoading={!unfilteredItems.length}
      items={preparedItems}
      activeItem={isTariff ? activeTariff : { ebootisId: activeVariantId }}
      mode={displayType}
      isTariff={isTariff}
      onClick={handleClick}
    />
  );
}
